"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDesignerProductPreviewManager = createDesignerProductPreviewManager;
var _get = _interopRequireDefault(require("lodash/get"));
var storage = _interopRequireWildcard(require("../../Storage"));
var _Constants = require("./Constants");
var _ServiceLocator = require("../../ServiceLocator");
var _Selectors = require("../../Reducers/DesignArea/Selectors");
var _Selectors2 = require("../../Reducers/Configurator/Selectors");
var _Actions = require("../../Reducers/ImageGallery/Actions");
var _Modifiers = require("../../Reducers/DesignData/Modifiers");
var _DesignDataService = require("../../Services/DesignDataService");
var _getFirstDataURLFromScreenshotsObj = require("../../Modules/Visualization/Utils/getFirstDataURLFromScreenshotsObj");
var _createMessageInterface = _interopRequireDefault(require("../../Utils/createMessageInterface"));
var _excluded = ["event"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * A helper function that prepares the image data to be used on the design area
 * In case of design production methods with embroidery effect it also creates the color map for the image,
 * so it can be shown as it was added from the image edit dialog.
 * It uses memoization in order to minimize the execution time for repeated requests
 */
var prepareImageData = function createImageDataPreProcessor() {
  var lastHash;
  var imageDataMemo = new Map();
  function getImageDataHash(imageData) {
    return JSON.stringify(['identifier', 'preview.url', 'operations.clipping', 'operations.clippingColor'].map(function (prop) {
      return (0, _get["default"])(imageData, prop);
    }));
  }
  return /*#__PURE__*/function () {
    var _prepareImageData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(designArea, imageData) {
      var hash, state, designProductionMethod, patchedImageData, colorPreviewRequired, vectorizedLogoMandatory, svgContent, svgColors, vectorizeColorsMap;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            hash = getImageDataHash(imageData);
            if (hash !== lastHash) {
              lastHash = hash;
              imageDataMemo.clear();
            }
            state = _ServiceLocator.Services.store.state;
            designProductionMethod = (0, _Selectors.getSelectedDesignProductionMethodForDesignArea)(state, designArea);
            if (!imageDataMemo.has(designProductionMethod.identifier)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", imageDataMemo.get(designProductionMethod.identifier));
          case 6:
            colorPreviewRequired = (0, _Selectors.designProductionMethodHasEmbroideryVisualizationEffect)(designProductionMethod);
            vectorizedLogoMandatory = (0, _Selectors.isVectorizedLogoMandatory)(designProductionMethod);
            if (!colorPreviewRequired) {
              _context.next = 17;
              break;
            }
            _context.next = 11;
            return (0, _DesignDataService.getSvgContent)(imageData.preview.url, false, true);
          case 11:
            svgContent = _context.sent;
            svgColors = (0, _DesignDataService.getSvgColors)(svgContent, designProductionMethod);
            vectorizeColorsMap = (0, _Modifiers.createVectorizeColorsMap)({}, svgColors);
            patchedImageData = _objectSpread(_objectSpread({}, imageData), {}, {
              colorPreviewRequired: true,
              displayColorPreview: true,
              colorPreviewEnabled: !vectorizedLogoMandatory,
              operations: _objectSpread(_objectSpread({}, imageData.operations), {}, {
                vectorizeColorsMap: vectorizeColorsMap
              })
            });
            _context.next = 18;
            break;
          case 17:
            // the color replacement call returns the same url for every call, making the browser serve the image
            // from cache, to force reloading a random query string has to be added to the url
            patchedImageData = _objectSpread(_objectSpread({}, imageData), {}, {
              preview: _objectSpread(_objectSpread({}, imageData.preview), {}, {
                url: imageData.preview.url.replace(/svg|png$/, "png?".concat(Math.random()))
              })
            });
          case 18:
            imageDataMemo.set(designProductionMethod.identifier, patchedImageData);
            return _context.abrupt("return", patchedImageData);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function prepareImageData(_x, _x2) {
      return _prepareImageData.apply(this, arguments);
    }
    return prepareImageData;
  }();
}();

/**
 * Creates a preview item object, which is responsible for
 *  - loading the product,
 *  - adding the image to the design area,
 *  - creating the preview image
 *  - additionally it helps to control the flow
 * @param identifier
 * @param event
 */
function createPreviewItem(identifier, event) {
  var PreviewItemStatus = {
    pending: 1,
    loading: 2,
    loaded: 3,
    screenshotting: 4,
    finished: 5
  };
  var status = PreviewItemStatus.pending;
  var image;
  var error;

  /**
   * @return {Promise<void>}
   */
  function load() {
    return _load.apply(this, arguments);
  }
  /**
   * @param {object} imageData
   * @param {object} size
   * @return {Promise<{identifier: string, image: string, error: string, event: *}|undefined>}
   */
  function _load() {
    _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            status = PreviewItemStatus.loading;
            _context2.prev = 1;
            _ServiceLocator.Services.configurator.setLoadIdentifier(identifier);
            _context2.next = 5;
            return _ServiceLocator.Services.configurator.loadConfigurationForDesignerProductPreview();
          case 5:
            status = PreviewItemStatus.loaded;
            _context2.next = 12;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            error = _context2.t0.toString();
            status = PreviewItemStatus.finished;
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 8]]);
    }));
    return _load.apply(this, arguments);
  }
  function createImage(_x3, _x4) {
    return _createImage.apply(this, arguments);
  }
  function _createImage() {
    _createImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(imageData, size) {
      var state, filteredDesignAreas, defaultDesignAreaIdentifier, designArea, areaList, viewList, variantList, screenshot;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(status === PreviewItemStatus.loaded)) {
              _context3.next = 4;
              break;
            }
            status = PreviewItemStatus.screenshotting;
            _context3.next = 5;
            break;
          case 4:
            return _context3.abrupt("return");
          case 5:
            _context3.prev = 5;
            state = _ServiceLocator.Services.store.state;
            filteredDesignAreas = state.designArea.filteredDesignAreas;
            defaultDesignAreaIdentifier = (0, _Selectors.getDefaultDesignAreaIdentifierFromProductionMethod)(state);
            designArea = filteredDesignAreas.find(function (_ref) {
              var identifier = _ref.identifier;
              return identifier === defaultDesignAreaIdentifier;
            }) || filteredDesignAreas[0];
            areaList = designArea ? [designArea.identifier] : [];
            viewList = (0, _Selectors.getCameraViewListForDesignAreaList)(filteredDesignAreas, areaList);
            variantList = [(0, _Selectors2.getSelectedVariantIdentifier)(state.configurator)];
            _ServiceLocator.Services.designData.toggleHighlight(false, false);
            if (!designArea) {
              _context3.next = 22;
              break;
            }
            _context3.t0 = _ServiceLocator.Services.designData;
            _context3.t1 = designArea;
            _context3.next = 19;
            return prepareImageData(designArea, imageData);
          case 19:
            _context3.t2 = _context3.sent;
            _context3.next = 22;
            return _context3.t0.addImageToDesignArea.call(_context3.t0, _context3.t1, _context3.t2);
          case 22:
            _context3.next = 24;
            return _ServiceLocator.Services.visualization.getScreenshots({
              areaList: areaList,
              viewList: viewList,
              variantList: variantList,
              size: size
            });
          case 24:
            screenshot = _context3.sent;
            image = (0, _getFirstDataURLFromScreenshotsObj.getFirstDataURLFromScreenshotsObj)(screenshot);
            status = PreviewItemStatus.finished;
            _context3.next = 33;
            break;
          case 29:
            _context3.prev = 29;
            _context3.t3 = _context3["catch"](5);
            error = _context3.t3.toString();
            status = PreviewItemStatus.finished;
          case 33:
            return _context3.abrupt("return", {
              identifier: identifier,
              image: image,
              error: error,
              event: event
            });
          case 34:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[5, 29]]);
    }));
    return _createImage.apply(this, arguments);
  }
  return {
    load: load,
    createImage: createImage,
    isFinished: function isFinished() {
      return status === PreviewItemStatus.finished;
    }
  };
}

/**
 * Helper interface for localStorage
 * @param {object} options
 */
function createStorage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$localStorage = options.localStorage,
    localStorage = _options$localStorage === void 0 ? storage : _options$localStorage;
  return {
    /**
     * @param {string} key
     * @param {any} value
     */
    set: function set(key, value) {
      localStorage.local.setItem(key, JSON.stringify(value));
    },
    /**
     * @param {string} key
     * @return {any}
     */
    get: function get(key) {
      try {
        var serializedValue = localStorage.local.getItem(key);
        return serializedValue && JSON.parse(serializedValue);
      } catch (e) {
        // ignore errors
      }
    }
  };
}

/**
 * Provides interface to both the container window (with postMessage API) and the React component
 * Further responsibilities:
 *  - stores the applied image in localStorage or in memory if not available and restores it on page load
 *  - hooks into the visualization service to get notified when it is ready to create the preview image
 * @param {object} options
 */
function createDesignerProductPreviewManager() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$localStorage2 = options.localStorage,
    localStorage = _options$localStorage2 === void 0 ? createStorage() : _options$localStorage2,
    _options$messageInter = options.messageInterface,
    messageInterface = _options$messageInter === void 0 ? (0, _createMessageInterface["default"])() : _options$messageInter;
  var currentImageData = localStorage.get(_Constants.imageDataKey);
  var size = {
    width: 200,
    height: 200
  };
  var currentItem;
  var previewRequests = [];
  var previewStack = [];

  //// actions provided for the container window

  /**
   * Usage from the container window:
   * configuratorIframe.postMessage({
   *   type: 'setItemIdentifiers',
   *   identifiers: ['product1', 'product2', ...]
   * })
   * @param event
   */
  messageInterface.addListener('setItemIdentifiers', function setItemIdentifiers(event) {
    previewRequests.length = 0; // clear all previous element
    var identifiers = (0, _get["default"])(event, 'data.identifiers') || [];
    identifiers.forEach(function (identifier) {
      previewRequests.push({
        identifier: identifier,
        event: event
      });
    });

    // if image is available, update products when new identifiers arrive
    if ((0, _get["default"])(currentImageData, 'preview.url')) {
      updateImages();
    }
  });

  /**
   * Usage from the container window:
   * configuratorIframe.postMessage({
   *   type: 'setSize',
   *   size: { width: 800, height: 600 }
   * })
   * @param event
   */
  messageInterface.addListener('setSize', function setSize(event) {
    var width = +(0, _get["default"])(event, 'data.size.width');
    var height = +(0, _get["default"])(event, 'data.size.height');
    if (width) {
      size.width = width;
    }
    if (height) {
      size.height = height;
    }
  });

  //// actions dispatched to the container window

  // notifies the origin if a preview image is ready to be shown
  function dispatchPreviewItem(screenshotItem) {
    var event = screenshotItem.event,
      previewData = _objectWithoutProperties(screenshotItem, _excluded);
    messageInterface.dispatch(_objectSpread({
      type: 'configuratorware_designer_preview_widget_dataready'
    }, previewData), {
      targetWindow: event.source
    });
  }

  // tells the container window the preview widget is ready and started listening for actions
  function dispatchLoaded() {
    messageInterface.dispatch({
      type: 'configuratorware_designer_preview_widget_loaded'
    });
  }

  //// flow control helpers

  function processNextProduct() {
    setTimeout(function () {
      if (currentItem && !currentItem.isFinished()) {
        return;
      }
      currentItem = previewStack.pop();
      if (!currentItem) {
        _ServiceLocator.Services.ui.hide(_Constants.loaderKey);
        return;
      }
      currentItem.load();
    });
  }
  function createPreviewImage() {
    return _createPreviewImage.apply(this, arguments);
  }
  function _createPreviewImage() {
    _createPreviewImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var previewItem;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (currentItem) {
              _context4.next = 3;
              break;
            }
            processNextProduct();
            return _context4.abrupt("return");
          case 3:
            _context4.next = 5;
            return currentItem.createImage(currentImageData, size);
          case 5:
            previewItem = _context4.sent;
            if (!(!currentItem.isFinished() || !previewItem)) {
              _context4.next = 8;
              break;
            }
            return _context4.abrupt("return");
          case 8:
            dispatchPreviewItem(previewItem);
            processNextProduct();
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _createPreviewImage.apply(this, arguments);
  }
  function updateImages() {
    currentItem = null;
    _ServiceLocator.Services.ui.show(_Constants.loaderKey);
    previewRequests.forEach(function (_ref2) {
      var identifier = _ref2.identifier,
        event = _ref2.event;
      previewStack.push(createPreviewItem(identifier, event));
    });
    processNextProduct();
  }

  //// the public interface provided to the React component

  /**
   * @param {function} [options.onRestoreImage]
   */
  function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var onRestoreImage = options.onRestoreImage;

    // first rendering triggers the preview image creation
    _ServiceLocator.Services.visualization.registerVisualizationUpdateListener(createPreviewImage);

    // restore the image data directly (if there is any)
    currentImageData && _ServiceLocator.Services.store.dispatch((0, _Actions.setSelectedImageData)(currentImageData));
    currentImageData && onRestoreImage && setTimeout(function () {
      return onRestoreImage(currentImageData);
    });
    dispatchLoaded();
  }

  /**
   * @param {object} [imageData]
   */
  function useImage() {
    var imageData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ServiceLocator.Services.store.state.imageGallery.selectedImage;
    currentImageData = imageData;
    localStorage.set(_Constants.imageDataKey, imageData);
    previewRequests.length && updateImages();
  }
  return {
    init: init,
    useImage: useImage
  };
}